import ProductDetails from '../ProductTour/ProductDetails'
import styles from './Campaign.module.scss'

const CampaignVideoLinks = ({ title, description, tabs, avoidRtl }) => {
  return (
    <div className="mb-10" id="video-links">
      <div className="page-container">
        {title && <h2 className={styles.linksTitle}>{title}</h2>}
        {description && <div className={styles.linksDesc}>{description}</div>}
      </div>
      <ProductDetails details={{ cards: tabs }} avoidRtl={avoidRtl} />
    </div>
  )
}

export default CampaignVideoLinks
